import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useBanks = () => {
  const context = useAuthContext();
  const [banks, setBanks] = useState([]);
  const { data, loading, refetch } = useQuery(Queries.getUserBanks, {
    fetchPolicy: 'network-only',
    context,
  });

  useEffect(() => {
    if (data && data.getCurrentUser) {
      setBanks(data.getCurrentUser.banks);
    }
  }, [data]);

  return [banks, loading, refetch];
};

export default useBanks;
